import AddUserButton from '../../../features/users/components/AddUserButton';
import UserCard from '../../../features/users/components/userCard/UserCard';

import useUsers from '../../../features/users/useUsers';
import './teamTab.scss';

const TeamTab = () => {
  const { usersWithoutAuthUser } = useUsers();

  return (
    <>
      <section className="my-account-content user-team">
        <header className="user-team-header">
          <h2 className="user-team-title">Equipe</h2>
          <AddUserButton />
        </header>

        <div className="user-team-content">
          {usersWithoutAuthUser?.map((user: IUser) => (
            <UserCard key={user.idIri} user={user} />
          ))}
        </div>
      </section>
    </>
  );
};

export default TeamTab;
